import { Copy } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { fill, copyOut, personalLink } from "@/lib/partnerKit";
import { Section } from "@/components/partner/Section";

function Block({ title, text, testId }) {
  return (
    <div className="rounded-2xl border border-border bg-card/30 p-4" data-testid={testId}>
      <div className="flex items-start justify-between gap-3">
        {title && <p className="text-xs uppercase tracking-[0.16em] text-primary">{title}</p>}
        <button onClick={() => copyOut(text)} className="ml-auto text-muted-foreground hover:text-primary shrink-0" aria-label="Copy" data-testid={`${testId}-copy`}><Copy className="w-4 h-4" /></button>
      </div>
      <p className="text-sm leading-relaxed whitespace-pre-line mt-1.5">{text}</p>
    </div>
  );
}

const List = ({ items }) => <ul className="space-y-2 text-sm">{items.map((t, i) => <li key={i} className="flex gap-3"><span className="text-primary">·</span>{t}</li>)}</ul>;

export default function Resources({ k }) {
  const c = k.copy;
  const f = (t, ch = "dm") => fill(t, { name: k.name, link: personalLink(k.slug, ch), code: k.code });
  const groups = [
    ["what", "What is Xcelio?", <div className="space-y-3"><p className="font-serif italic text-xl">{c.explain.tagline}</p><p className="text-sm text-muted-foreground">{c.explain.one_liner}</p>
      <Block title="10 seconds" text={c.explain.ten} testId="res-explain-10" /><Block title="30 seconds" text={c.explain.thirty} testId="res-explain-30" /><Block title="The longer version" text={c.explain.long} testId="res-explain-long" /></div>],
    ["dms", "Message templates", <div className="space-y-3">{c.dms.map((d, i) => <Block key={i} title={d.title} text={f(d.text)} testId={`res-dm-${i}`} />)}</div>],
    ["objections", "When people ask…", <div className="space-y-3">{c.objections.map((o, i) => <Block key={i} title={o.q} text={o.a} testId={`res-obj-${i}`} />)}</div>],
    ["newsletter", "Newsletter copy", <Block text={f(c.newsletter, "email")} testId="res-newsletter" />],
    ["ideas", "Content ideas", <List items={c.content_ideas} />],
    ["plan", "30-day plan (optional)", <div className="space-y-3">{c.plan_weeks.map((w, i) => <Block key={i} title={w.title} text={w.text} testId={`res-plan-${i}`} />)}</div>],
    ["brand", "Brand guidelines and assets", <div className="space-y-4"><List items={c.brand} /><a href="/promo" className="inline-block text-sm text-primary hover:underline" data-testid="res-promo-link">Get ready-to-post graphics with Adelaida →</a></div>],
    ["compliance", "Compliance wording", <List items={c.compliance} />],
    ["terms", "Commission terms", <List items={c.terms} />],
  ];
  return (
    <Section id="resources" eyebrow="Partner resources" title="Everything else, when you want it">
      <Accordion type="single" collapsible className="rounded-3xl border border-border bg-card/30 px-5">
        {groups.map(([key, title, body]) => (
          <AccordionItem key={key} value={key} className="border-border">
            <AccordionTrigger className="font-serif text-lg hover:no-underline" data-testid={`res-${key}`}>{title}</AccordionTrigger>
            <AccordionContent>{body}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </Section>
  );
}
